module.exports = __webpack_public_path__ + "static/media/home.f3d6e3bb.png";